export default {"src":"/_next/static/media/placeholder-2.8035cd64.svg","height":190,"width":352};